import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {Ofwca} from '../../../shared/interface/ofwca';
import {MeetingService} from '../../../shared/services/meeting.service';
import {takeUntil} from 'rxjs/operators';
import {MatTableDataSource} from '@angular/material/table';
import {OfwcaMeeting} from '../../../shared/interface/ofwca-meeting';
import {ListResponse} from '../../../shared/interface/response/list-response';
import {MatPaginator} from '@angular/material/paginator';

@Component({
  selector: 'app-ofwca-meeting-list',
  templateUrl: './ofwca-meeting-list.component.html',
  styleUrls: ['./ofwca-meeting-list.component.scss']
})
export class OfwcaMeetingListComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() ofwca: Observable<Ofwca>;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ofwcaMeetingDataSource: MatTableDataSource<OfwcaMeeting> = new MatTableDataSource<OfwcaMeeting>([]);
  displayedColumns: string[] = ['meeting', 'logo', 'insuranceCompany', 'examType', 'place', 'status', 'startsAt', 'passed', ];

  constructor(
    private meetingService: MeetingService,
  ) { }

  ngOnInit(): void {
    this.ofwca
      .pipe(takeUntil(this.destroyed$))
      .subscribe((ofwca: Ofwca) => {
        this.meetingService.getOfwcaMeetings(ofwca.uuid)
          .subscribe((response: ListResponse<OfwcaMeeting>) => {
            this.ofwcaMeetingDataSource.data = response.items;
          });
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this.ofwcaMeetingDataSource.paginator = this.paginator;
  }
}
